import { Pricings } from '@brands/services/identity/getPricings';

import { RootState } from '../store';

export const selectOrganizationPrices = (state: RootState): any => state.organizationPrices;

export const selectCurrentOrganizationPrices = (state: RootState): Pricings[] | null =>
  state.organizationPrices.currentOrganizationPrices;
